import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import useExportTraces from "./useExportTraces";

const ExportTracesMenuItem = () => {
  const { hasTraces, label, openDrawer } = useExportTraces();

  if (!hasTraces) {
    return null;
  }

  return <DropdownMenuItem onAction={openDrawer}>{label}</DropdownMenuItem>;
};

export default ExportTracesMenuItem;
